import { render, staticRenderFns } from "./BuyConfirm.vue?vue&type=template&id=1f6c54e2&scoped=true"
import script from "./BuyConfirm.vue?vue&type=script&lang=js"
export * from "./BuyConfirm.vue?vue&type=script&lang=js"
import style0 from "./BuyConfirm.vue?vue&type=style&index=0&id=1f6c54e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6c54e2",
  null
  
)

export default component.exports